
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as finishMXBNYacDMaxLG8J9H996_d_45lmejRvuo8az3bR7RwsPgMeta } from "/app/src/pages/finish.vue?macro=true";
import { default as om_45ossnyTx4Bgxe6C4_45I_45tkhJCD98Lgbk9jDqDGSz7Hq6QzZYMeta } from "/app/src/pages/om-oss.vue?macro=true";
import { default as byt_45konhKq3F9zqTnJmHy0GEbHjGXdEA7H59HZynL6M_zqttysMeta } from "/app/src/pages/byt-kon.vue?macro=true";
import { default as elavtal3pHva6WG3jkVNT5TQ8qbMBmyH_45CdtL3llPqTm1E7hF8Meta } from "/app/src/pages/elavtal.vue?macro=true";
import { default as villkorSvEPzROrkt9kFX_45SnKIthp3h0HIZ4Z00sFHot59_455VkMeta } from "/app/src/pages/villkor.vue?macro=true";
import { default as bli_45kundqM2qQz3IXNgt3OlvMk0i69PH0pvwQ3Zq7RCto1A_HJUMeta } from "/app/src/pages/bli-kund.vue?macro=true";
import { default as fullmaktOa3_45jmd7Ki8dCRNX3OpYLDyuaTbollWOfItrCY6_gO4Meta } from "/app/src/pages/fullmakt.vue?macro=true";
import { default as foretag_45brfabluMQLfGtkxf9SgrRJoooAF7IZzUODOOsetbVOXhTMMeta } from "/app/src/pages/foretag-brf.vue?macro=true";
import { default as kundservicezNjEZnW4CSqh8fBaaQ6UZ6DQsK3x4S_45ZXGX9eUd7uWgMeta } from "/app/src/pages/kundservice.vue?macro=true";
import { default as salj_45din_45elL_HNoWbIm1dsHIIM_2zOO32YLwm7M5JzTRkrt8cHH5QMeta } from "/app/src/pages/salj-din-el.vue?macro=true";
import { default as indexgoFSXQN9vXPyGqyorAVbrmOASZstwWwZ8Lsa63PDEFgMeta } from "/app/src/pages/nyheter/index.vue?macro=true";
import { default as _91slug_93vag8OueKbVDl7dC2tkKAXQFWR_4gdSxgC1PtjjBJs_gMeta } from "/app/src/pages/nyheter/[slug].vue?macro=true";
import { default as integritetspolicyEMyUBkGL7mmVlAIG2kroBVBpmMLxoMH0zI1UilaoSgwMeta } from "/app/src/pages/integritetspolicy.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "finish",
    path: "/finish",
    component: () => import("/app/src/pages/finish.vue")
  },
  {
    name: "om-oss",
    path: "/om-oss",
    component: () => import("/app/src/pages/om-oss.vue")
  },
  {
    name: "byt-kon",
    path: "/byt-kon",
    component: () => import("/app/src/pages/byt-kon.vue")
  },
  {
    name: "elavtal",
    path: "/elavtal",
    component: () => import("/app/src/pages/elavtal.vue")
  },
  {
    name: "villkor",
    path: "/villkor",
    component: () => import("/app/src/pages/villkor.vue")
  },
  {
    name: "bli-kund",
    path: "/bli-kund",
    component: () => import("/app/src/pages/bli-kund.vue")
  },
  {
    name: "fullmakt",
    path: "/fullmakt",
    component: () => import("/app/src/pages/fullmakt.vue")
  },
  {
    name: "foretag-brf",
    path: "/foretag-brf",
    component: () => import("/app/src/pages/foretag-brf.vue")
  },
  {
    name: "kundservice",
    path: "/kundservice",
    component: () => import("/app/src/pages/kundservice.vue")
  },
  {
    name: "salj-din-el",
    path: "/salj-din-el",
    component: () => import("/app/src/pages/salj-din-el.vue")
  },
  {
    name: "nyheter",
    path: "/nyheter",
    component: () => import("/app/src/pages/nyheter/index.vue")
  },
  {
    name: "nyheter-slug",
    path: "/nyheter/:slug()",
    component: () => import("/app/src/pages/nyheter/[slug].vue")
  },
  {
    name: "integritetspolicy",
    path: "/integritetspolicy",
    component: () => import("/app/src/pages/integritetspolicy.vue")
  }
]